class BullardWelcomePromo extends HTMLElement {
  connectedCallback() {
    this.offer = this.querySelector('[data-welcome-offer]');
    this.fallback = this.querySelector('[data-welcome-fallback]');
    this.refresh = this.refresh.bind(this);
    window.addEventListener('pageshow', this.refresh);
    this.refresh();
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    window.removeEventListener('pageshow', this.refresh);
  }
  refresh() {
    clearTimeout(this.timer);
    if (!this.offer || !this.fallback) return;
    const start = Date.parse(this.dataset.start);
    const end = Date.parse(this.dataset.end);
    const now = Date.now();
    const valid = this.dataset.enabled === 'true' && Number.isFinite(start) && Number.isFinite(end) && end > start;
    const active = valid && now >= start && now < end;
    this.offer.hidden = !active;
    this.fallback.hidden = active;
    const next = valid && now < start ? start : active ? end : null;
    if (next !== null) this.timer = setTimeout(this.refresh, Math.min(next - now + 10, 2147483647));
  }
}
if (!customElements.get('bullard-welcome-promo')) customElements.define('bullard-welcome-promo', BullardWelcomePromo);
